import React from "react";
import Link from "gatsby-link";
import { getRoomPrice, getParamFromQueryString } from "../../utils/app-helpers";
import GatsbyConfig from "../../../gatsby-config.js";
import RoomRibbon from "./room-ribbon";

const { siteMetadata: config } = GatsbyConfig;

export default class RoomCard extends React.Component {
  formatPrice(price) {
    return price > 999
      ? `$${price}`.replace(/(.+)(\d{3})$/, "$1,$2")
      : `$${price}`;
  }

  render() {
    if (typeof window === "undefined") return <div />;
    const { trip, room, monthlyPrice, upgraded } = this.props;
    const tripData = config.trips[trip];
    const price = getRoomPrice(tripData, room);
    const pricePerPerson = Math.round((price - tripData.taxesAndFees) / 2);
    const promo = window.location.href.match(/\/onlocation/i)
      ? "onlocation"
      : getParamFromQueryString("promo", window.location.href);
    const fromTab = getParamFromQueryString("tab", window.location.href);
    const isValidTab = ["rooms", "suites", "all"].includes(fromTab);
    const queryParams = [`room=${room.key}`];
    const classNames = ["card", "room"];
    const isValidUpgrade =
      upgraded && Object.keys(tripData.rooms).includes(upgraded);
    const monthlyPricingAvailable =
      !tripData.disableMonthlyPaymentOption && monthlyPrice > 0;

    if (promo) queryParams.push(`promo=${promo}`);
    if (isValidUpgrade) queryParams.push(`upgraded=${upgraded}`);
    if (isValidTab) queryParams.push(`tab=${fromTab}`);
    if (room.kind !== "room") classNames.push(room.kind);
    if (room.kind === "hybrid" || room.highlighted)
      classNames.push("highlighted");
    if (tripData.soldOut || room.soldOut) classNames.push("soldout");

    return (
      <div className={classNames.join(" ")}>
        <RoomRibbon room={room} />
        <div
          style={{ backgroundImage: `url(${room.image})` }}
          className="image all-100x40"
        />
        <div className="body">
          <div>
            <h2>{room.name}</h2>
            <span className="note">
              {tripData.soldOut ? "Sold Out" : room.note}
            </span>
          </div>
          {!tripData.disableRoomPricing && (
            <span className="price">
              {monthlyPricingAvailable && (
                <span className="monthly">
                  {this.formatPrice(monthlyPrice)} <small>/mo</small>
                </span>
              )}
              <span className={`full${!monthlyPricingAvailable ? " big" : ""}`}>
                {this.formatPrice(pricePerPerson)} Per Person
              </span>
            </span>
          )}
        </div>
        <Link
          className="btn"
          to={`/${room.trip}/room/?${queryParams.join("&")}`}
        >
          View Details <i className="fa fa-angle-right" />
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/room-card.js